/**
 * The plain-text projection of a piece of html.
 *
 * Wanted wherever a `RichTextValue` has to be built from html that did not come
 * out of the editor — a stored campaign body being reopened, or one the model just
 * wrote. The editor itself emits the pair together (`innerHTML` beside
 * `innerText`); this is how a caller gets the second half when all it has is the
 * first, and it is deliberately the same mechanism so the two agree.
 */
export function htmlToText(html: string): string {
  const node = document.createElement('div');
  node.innerHTML = html;
  return node.innerText;
}
